//------------------------------------------------------------------------
// Filters toggle (only shown in mobile view)
//-----------------------------------------------------------------------
import ExpandToggle from '@threespot/expand-toggle';

export default class IntroToggle {
  constructor(el) {
    this.el = el;
    if (!this.el) {
      console.warn(`Unable to initialize expandable intro, no matching element for “${this.el}”`);
      return false;
    }

    // Get breakpoint from CSS var
    this.mobileNavBreakpoint = getComputedStyle(document.documentElement).getPropertyValue('--layout-intro-bp');
    this.mediaQueryList = window.matchMedia(`(min-width: ${this.mobileNavBreakpoint})`);

    // Listen for breakpoint change
    this.mediaQueryList.addListener(evt => {
      if (evt.matches) {
        this.destroyToggle();
      } else {
        this.initToggle();
      }
    });

    // Init on load
    if (!this.mediaQueryList.matches) {
      this.initToggle();
    }
  }

  initToggle() {
    this.toggleExpand = new ExpandToggle(this.el);
  }

  destroyToggle() {
    // Checks to see if this.toggleExpand exists
    if (typeof this.toggleExpand !== 'undefined') {
      this.toggleExpand.destroy();
    }
  }
}
